import { Button, Col, Modal, Skeleton, Table, Tooltip, Typography } from "antd";
import styled from "styled-components";

import {
  useFetchAiDialerCallConfigsQuery,
  useFetchAiDialerTemplatesQuery,
  useValidateAiDialerTemplatesMutation,
} from "features/aiDialerTemplates/aiDialerTemplatesAPI";
import { FileOutlined, FileSyncOutlined } from "@ant-design/icons";
import { useState } from "react";

const { Paragraph } = Typography;

const StyledTable = styled(Table)`
  cursor: pointer;
  margin-top: 12px;
`;

const StyledPre = styled.pre`
  background: #f6f8fa;
  padding: 16px;
  border-radius: 6px;
  overflow: auto;
`;

function AiDialerTemplatesTable() {
  const { data: aiDialerTemplates, isLoading: isAiDialerTemplateLoading } =
    useFetchAiDialerTemplatesQuery();
  const { data: aiDialerCallConfigs, isLoading: isAiDialerCallConfigsLoading } =
    useFetchAiDialerCallConfigsQuery();
  const [validateTemplate, { isLoading: isValidateTemplateLoading }] =
    useValidateAiDialerTemplatesMutation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState(null);
  const [title, setTitle] = useState(null);

  const handleCancel = () => {
    setIsModalOpen(false);
    setData(null);
  };

  const handleValidateTemplate = async (record) => {
    setIsModalOpen(true);
    setTitle("Template Validation Result");

    const result = await validateTemplate(record);
    if ("data" in result) {
      setData(result.data);
    }
  };

  const handleCallConfig = async (record) => {
    setIsModalOpen(true);
    setTitle("Call Configurations");
    setData(record?.configuration);
  };

  const columns = [
    {
      title: "Template ID",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Actions",
      fixed: "right",
      render: (_, record) => {
        return (
          <Tooltip placement="bottom" title="Validate Template" key="validate">
            <FileSyncOutlined key="edit" onClick={() => handleValidateTemplate(record)} />
          </Tooltip>
        );
      },
    },
  ];

  const callConfigColumns = [
    {
      title: "Configuration ID",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Actions",
      fixed: "right",
      render: (_, record) => {
        return (
          <Tooltip placement="bottom" title="See Configurations" key="validate">
            <FileOutlined key="edit" onClick={() => handleCallConfig(record)} />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <>
      <Col>
        <h4>AI Phone Agent Templates</h4>
        <StyledTable
          bordered
          loading={isAiDialerTemplateLoading}
          // @ts-ignore
          columns={columns}
          dataSource={aiDialerTemplates}
        />
        <h4>Call Configurations</h4>
        <StyledTable
          bordered
          loading={isAiDialerCallConfigsLoading}
          // @ts-ignore
          columns={callConfigColumns}
          dataSource={aiDialerCallConfigs}
        />
      </Col>

      <Modal
        title={title}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>,
        ]}
        width={700}
      >
        {isValidateTemplateLoading && <Skeleton active />}
        {data && (
          <Paragraph>
            <StyledPre>{JSON.stringify(data, null, 2)}</StyledPre>
          </Paragraph>
        )}
      </Modal>
    </>
  );
}

export default AiDialerTemplatesTable;
